<template>
<div class="chapter">
<div class="inner_page">
<section epub:type="bodymatter">
<span epub:type="pagebreak" id="p17" title="17">
<p class="icon"><span class="grey">[</span> QUICK PREP <span class="grey">]</span></p>
<h2 class="recipetitle" id="five_grain_buttermilk_cranberry_bread">Five-Grain Buttermilk-Cranberry Bread</h2>
<p class="recipetime"><span class="yield_black">1 loaf (12 slices)</span> <span class="separater">|</span> Prep Time: 15 Minutes <span class="separater">|</span> Start to Finish: 1 Hour 25 Minutes</p>
<p class="dot">•••</p>
<ul class="ingredient">
<li class="list"><span class="qty1">1</span> cup 5-grain rolled whole-grain cereal or old-fashioned oats</li>
<li class="list"><span class="qty1">3</span> cups white whole wheat flour</li>
<li class="list"><span class="qty1">⅓</span> cup packed brown sugar</li>
<li class="list"><span class="qty1">1</span> teaspoon baking soda</li>
<li class="list"><span class="qty1">1</span> teaspoon cream of tartar</li>
<li class="list"><span class="qty1">¾</span> teaspoon salt</li>
<li class="list"><span class="qty1">¼</span> cup cold butter, cut into small pieces</li>
<li class="list"><span class="qty1">½</span> cup sweetened dried cranberries, cherries or raisins</li>
<li class="list"><span class="qty1">1</span> egg</li>
<li class="list"><span class="qty1">1½</span> cups buttermilk</li>
</ul>
<p class="recipeprocedure"><span class="stepnum">1</span> Heat oven to 375°F. Grease large cookie sheet with shortening or cooking spray. Reserve 1 tablespoon of the cereal.</p>
<p class="recipeprocedure"><span class="stepnum">2</span> In large bowl, mix remaining cereal, the flour, brown sugar, baking soda, cream of tartar and salt. Cut in butter, using pastry blender or fork, until mixture looks like coarse crumbs. Stir in cranberries.</p>
<p class="recipeprocedure"><span class="stepnum">3</span> In small bowl, beat egg and buttermilk with whisk until well blended. Reserve 1 tablespoon buttermilk mixture. Add remaining buttermilk mixture to dry ingredients, stirring just until mixture is moistened (dough will be soft). On floured surface, knead dough 5 or 6 times.</p>
<p class="recipeprocedure"><span class="stepnum">4</span> On cookie sheet, shape dough into 7-inch round. Using sharp knife, cut large X shape, ¼ inch deep, into top of dough. Brush top of dough with reserved buttermilk mixture; sprinkle with reserved cereal.</p>
<p class="recipeprocedure"><span class="stepnum">5</span> Bake 35 to 40 minutes or until top is golden brown. Cool 30 minutes. Using serrated knife, cut into slices or wedges to serve.</p>
<p class="recipeprocedure"><span class="stepnum">6</span> To freeze, cool completely. Wrap tightly. Freeze up to 3 months. Thaw at room temperature.</p>
<p class="recipe_info"><span class="nutr_bold">1 Slice:</span> Calories 230; Total Fat 6g (Saturated Fat 3g, Trans Fat 0g); Cholesterol 30mg; Sodium 320mg; Total Carbohydrate 38g (Dietary Fiber 4g); Protein 6g <span class="nutr_bold">Exchanges:</span> 2 Starch, ½ Other Carbohydrate, 1 Fat <span class="nutr_bold">Carbohydrate Choices:</span> 2½</p>
<p class="recipe_note"><span class="tips">In a Flash</span> This cranberry bread is a star during the holidays. With it tucked away in the freezer, you have a jump start on Thanksgiving—or any other time you crave delicious bread.</p>
</span></section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// p017.vue?9f358536